import { useState, useEffect } from "react"

import {
  useDisclosure,
  Box,
  Button,
  Container,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react"

const Toolbar = ({ cart, onOrderClick }) => {
  const [total, setTotal] = useState(0)
  const chooseModalController = useDisclosure()

  useEffect(() => {
    if (cart) {
      setTotal(Object.values(cart).length)
    }
  }, [cart])

  return (
    <Box bg="gray.300" position="fixed" bottom="0" left="0" width="full">
      <Container maxW="container.sm" padding="4">
        <Button
          colorScheme="teal"
          onClick={() => chooseModalController.onOpen()}
          width="full"
        >
          Ordina ({total})
        </Button>
      </Container>
      <Modal
        isCentered
        isOpen={chooseModalController.isOpen}
        onClose={chooseModalController.onClose}
        size="sm"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cosa vuoi fare?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack direction="column">
              <Button
                onClick={() => {
                  chooseModalController.onClose()
                  window.scrollTo(0, 0)
                }}
                colorScheme="teal"
                mr={3}
              >
                Vedi altri Prodotti
              </Button>
              <Button
                onClick={() => {
                  chooseModalController.onClose()
                  onOrderClick()
                }}
                colorScheme="teal"
                mr={3}
              >
                Completa Ordine
              </Button>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  )
}

export default Toolbar
